var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { "separator-class": "el-icon-arrow-right" } },
        [
          _c("el-breadcrumb-item", [
            _c(
              "a",
              {
                attrs: {
                  href:
                    "/tjkStudy/interview?groupId=" +
                    _vm.groupId +
                    "&groupName=" +
                    _vm.groupName
                }
              },
              [_vm._v(_vm._s(_vm.groupName) + "的面试邀请")]
            )
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v("申请人详情")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", "margin-top": "20px" },
          attrs: { data: _vm.tjkList, border: "", "highlight-current-row": "" }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "tjkName",
              label: "淘金客",
              width: "180",
              align: "center"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "applyTime", label: "申请日期", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "mobilePhone", label: "电话号码", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "wechatNumber", label: "微信号", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "remark", label: "备注", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "通过状态", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.passState == "Passed"
                      ? _c("span", [_vm._v("已通过")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.passState == "Failed"
                      ? _c("span", [_vm._v("未通过")])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.passState == "Passed"
                      ? _c(
                          "span",
                          {
                            staticClass: "link-text",
                            on: {
                              click: function($event) {
                                return _vm.updateState(
                                  scope.row.applyId,
                                  "Failed"
                                )
                              }
                            }
                          },
                          [_vm._v("不通过")]
                        )
                      : scope.row.passState == "Failed"
                      ? _c(
                          "span",
                          {
                            staticClass: "link-text",
                            on: {
                              click: function($event) {
                                return _vm.updateState(
                                  scope.row.applyId,
                                  "Passed"
                                )
                              }
                            }
                          },
                          [_vm._v("通过")]
                        )
                      : [
                          _c(
                            "span",
                            {
                              staticClass: "link-text",
                              on: {
                                click: function($event) {
                                  return _vm.updateState(
                                    scope.row.applyId,
                                    "Failed"
                                  )
                                }
                              }
                            },
                            [_vm._v("不通过")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "link-text",
                              on: {
                                click: function($event) {
                                  return _vm.updateState(
                                    scope.row.applyId,
                                    "Passed"
                                  )
                                }
                              }
                            },
                            [_vm._v("通过")]
                          )
                        ],
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "link-text",
                        on: {
                          click: function($event) {
                            return _vm.addRemark(
                              scope.row.applyId,
                              scope.row.remark
                            )
                          }
                        }
                      },
                      [_vm._v("备注")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "link-text",
                        on: {
                          click: function($event) {
                            return _vm.queryTjkFun(scope.row.tjkId)
                          }
                        }
                      },
                      [_vm._v("个人信息")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.tjkList.length > _vm.pageSize
        ? _c("pagination", {
            attrs: { pages: _vm.pages, pageNum: _vm.pageNum },
            on: { getData: _vm.getTjkList }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.dialogVisibleTjk
        ? [
            _c("h3", [_vm._v("淘金客个人信息")]),
            _vm._v(" "),
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("平台昵称：" + _vm._s(_vm.nick))
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("我的优势：" + _vm._s(_vm.advantage))
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("平台外客服经验：" + _vm._s(_vm.experience))
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("是否有小孩：" + _vm._s(_vm.haveChildren))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("年龄：" + _vm._s(_vm.age))
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("最低接受薪酬：" + _vm._s(_vm.lowestSalary))
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("绑定微信：" + _vm._s(_vm.wechatId))
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("每天可工作时长：" + _vm._s(_vm.workHours))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 6 } }, [_vm._v("推荐人：无")]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("注册来源：" + _vm._s(_vm.channel))
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _c(
                    "p",
                    [
                      _c("span", [_vm._v("擅长语种：")]),
                      _vm._v(" "),
                      _vm._l(_vm.language, function(item, index) {
                        return _c("span", [
                          _vm._v("\n              " + _vm._s(item)),
                          index < _vm.language.length - 1
                            ? _c("span", [_vm._v(" 、")])
                            : _vm._e()
                        ])
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _c(
                    "p",
                    [
                      _c("span", [_vm._v("平台外经验工作类型：")]),
                      _vm._v(" "),
                      _vm._l(_vm.experienceWork, function(item, index) {
                        return _c("span", [
                          _vm._v("\n              " + _vm._s(item)),
                          index < _vm.experienceWork.length - 1
                            ? _c("span", [_vm._v(" 、")])
                            : _vm._e()
                        ])
                      })
                    ],
                    2
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("注册日期：" + _vm._s(_vm.registerTime))
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("\n          客服标签：\n          "),
                  _vm.providerTag == "HH"
                    ? _c("span", [_vm._v("合伙人")])
                    : _vm.providerTag == "ZJ"
                    ? _c("span", [_vm._v("自建职场")])
                    : _vm.providerTag == "LY"
                    ? _c("span", [_vm._v("联营")])
                    : _c("span", [_vm._v("平台客服")])
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _c(
                    "p",
                    [
                      _c("span", [_vm._v("期望工作类型：")]),
                      _vm._v(" "),
                      _vm._l(_vm.expectedWork, function(item, index) {
                        return _c("span", [
                          _vm._v("\n              " + _vm._s(item)),
                          index < _vm.expectedWork.length - 1
                            ? _c("span", [_vm._v(" 、")])
                            : _vm._e()
                        ])
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("所属团队：" + _vm._s(_vm.providerName))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("最高学历：" + _vm._s(_vm.education))
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _c(
                    "p",
                    [
                      _c("span", [_vm._v("擅长行业：")]),
                      _vm._v(" "),
                      _vm._l(_vm.industryed, function(item, index) {
                        return _c("span", [
                          _vm._v("\n              " + _vm._s(item)),
                          index < _vm.industryed.length - 1
                            ? _c("span", [_vm._v(" 、")])
                            : _vm._e()
                        ])
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 6 } }, [
                  _vm._v("特殊任务要求：" + _vm._s(_vm.acceptShortProject))
                ])
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "备注",
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "modal",
              attrs: {
                model: _vm.modal,
                rules: _vm.rules,
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "description" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      type: "textarea",
                      autosize: "",
                      placeholder: "请控制在100个字内",
                      clearable: ""
                    },
                    model: {
                      value: _vm.modal.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.modal, "remark", $$v)
                      },
                      expression: "modal.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addRemarkFun } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74d5c8e3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74d5c8e3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/college/interviewTjk.vue
// module id = 1192
// module chunks = 0